import React from 'react'
import NextImage from 'next/image'
import styled from '@emotion/styled'
import useConfig from '../../../config/state/use-config'
import { UiIcon } from '../../../ui/atoms/Icon'

interface StepLayoutRootProps {
  children: React.ReactNode
}

export default function StepLayoutRoot({ children }: StepLayoutRootProps) {
  const config = useConfig()

  return (
    <Root>
      <div>
        <Header>
          <LogoLink href={config.header.logoLink} title={config.header.logoAltText}>
            <Logo
              height={36}
              width={72}
              alt={config.header.logoAltText}
              src={config.header.logoAssetUrl}
            />
          </LogoLink>
          <MobileBackLink href={config.header.logoLink} title="Back to campaign page">
            <UiIcon name="chevron_left" w={20} h={20} />
          </MobileBackLink>
        </Header>

        <DesktopBackLink href={config.header.logoLink}>
          <UiIcon name="chevron_left" w={20} h={20} />
          <span className="text">Campaign page</span>
        </DesktopBackLink>
      </div>

      <Main>{children}</Main>
    </Root>
  )
}

const Root = styled.div`
  gap: 64px;
  display: flex;
  flex-direction: column;
`

const Header = styled.header`
  top: 0;
  display: flex;
  height: 64px;
  padding: 0 16px;
  position: sticky;
  align-items: center;
  background-color: white;
  border-bottom: 1px solid #eaeaea;
  justify-content: center;

  @media (min-width: 769px) {
    justify-content: flex-start;
  }
`

const LogoLink = styled.a`
  display: flex;
  align-items: center;
`

const MobileBackLink = styled.a`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;

  @media (min-width: 769px) {
    display: none;
  }
`

const DesktopBackLink = styled.a`
  display: none;

  @media (min-width: 769px) {
    display: flex;
    align-items: center;
    padding: 8px 16px 0;
    color: inherit;
    text-decoration: none;
    font-size: 14px;

    .text {
      margin-left: 4px;
    }
  }
`

const Logo = styled(NextImage)``

const Main = styled.main`
  padding: 0 16px;
`
